import React, { Component } from 'react';
import $ from 'jquery';
import Message from './ValidationMessage';

export class DropdownMultipleFieldEdit extends Component {

  refresh() {
    $(`.ui.dropdown.renderDropDownMultiple`).dropdown({
      forceSelection: false
    });
  }

  render() {

    let {
      intl,
      translation,
      meta: { touched, error, warning },
      input,
      id,
      idField = 'id',
      displayField = 'name',
      activeOnly = true,
      required,
      label,
      disabled,
      list = []
    } = this.props;

    if (intl && translation) {
      const labelObj = translation.label;
      if(labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }
    
    let content = [];

    const showError = touched && error ? 'error' : '';
    const requiredClass = required ? 'required' : '';
    const name = input ? input.name : '';
    if (!Array.isArray(input.value)) {
      input.value = [input.value];
    }

    const optionList = list.reduce((accumulator = [], item) => {
      if (item) {
        const idVal = item[idField];
        if (idVal != null) {
          const optionId = idVal;
          const optionValue = idVal;
          const optionLabel = item[displayField];

          const inputValues = input && input.value;
          inputValues.forEach((input) => {
            if(input === optionValue){
              content.push(optionLabel);
            }
          });

          if (activeOnly) {
            if (!item.hasOwnProperty('active') || item.active) {
              accumulator.push((
                <option key={optionId} value={optionValue}>{optionLabel}</option>
              ));
            }
          }
          else {
            accumulator.push((
              <option key={optionId} value={optionValue}>{optionLabel}</option>
            ));
          }
        }
      }
      return accumulator;
    }, []);

    return (
      <div className={`${requiredClass} ${disabled && 'disabled'} field ${showError}`}>
        <label>{label}</label>
        <select {...input} className={`ui fluid multiple selection search dropdown renderDropdownMultiple ${name}`} multiple name={name} id={id}>
          <option value="" />
          {optionList}
        </select>
        <Message show={touched} message={error} />
        <Message show={touched} message={warning} />
      </div>
    );
  }
}
